import { Component, Input } from '@angular/core';

@Component({
  selector: 'csa-generic-error-card',
  templateUrl: './generic-error-card.component.html',
  styleUrls: ['./generic-error-card.component.sass'],
  standalone: false,
})
export class GenericErrorCardComponent {
  @Input() headerTitle: string;
  @Input() errorText: string;
}
